import { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const PANELS = [
  {
    num: '01',
    title: 'Ocean Villa',
    sub: 'Floor-to-ceiling glass. Private plunge pool. Unbroken horizon.',
    image:
      'https://readdy.ai/api/search-image?query=Ultra-realistic%20architectural%20photograph%20of%20a%20luxury%20oceanfront%20suite%20interior%20with%20floor%20to%20ceiling%20glass%20walls%20opening%20to%20a%20private%20plunge%20pool%20and%20the%20Caribbean%20sea%2C%20minimalist%20warm%20wood%20and%20linen%20furniture%2C%20soft%20natural%20afternoon%20light%2C%20muted%20neutral%20palette%2C%20editorial%20architectural%20digest%20aesthetic&width=2400&height=1600&seq=stacked-ocean-villa-01&orientation=landscape',
    alt: 'Luxury oceanfront villa suite with floor to ceiling glass',
  },
  {
    num: '02',
    title: 'Garden Suite',
    sub: 'Courtyard gardens and open-air rain showers.',
    image:
      'https://readdy.ai/api/search-image?query=Ultra-realistic%20architectural%20photograph%20of%20a%20luxury%20tropical%20garden%20suite%20interior%20with%20private%20courtyard%2C%20open%20air%20rain%20shower%2C%20lush%20green%20plants%2C%20warm%20wood%20tones%2C%20natural%20stone%2C%20soft%20diffused%20daylight%2C%20minimal%20contemporary%20design%2C%20editorial%20architectural%20magazine%20aesthetic%2C%20muted%20warm%20palette&width=2400&height=1600&seq=stacked-garden-suite-02&orientation=landscape',
    alt: 'Luxury tropical garden suite with open air shower',
  },
  {
    num: '03',
    title: 'Cliff Residence',
    sub: 'The highest point of the property. The last light of every day.',
    image:
      'https://readdy.ai/api/search-image?query=Ultra-realistic%20architectural%20photograph%20of%20a%20modern%20cliffside%20residence%20perched%20high%20above%20the%20Caribbean%20sea%2C%20board-formed%20concrete%20geometry%2C%20cantilevered%20terrace%2C%20infinity%20pool%20at%20sunset%2C%20warm%20golden%20light%2C%20lush%20jungle%20surrounding%2C%20editorial%20architectural%20digest%20aesthetic%2C%20muted%20natural%20tones&width=2400&height=1600&seq=stacked-cliff-residence-03&orientation=landscape',
    alt: 'Modern cliffside residence at sunset',
  },
];

export default function StackedPanels() {
  const rootRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const isNarrow = window.innerWidth <= 760;
      if (prefersReduced || isNarrow) return;

      const panels = gsap.utils.toArray<HTMLElement>('.stacked__panel');
      panels.forEach((panel, i) => {
        if (i === panels.length - 1) return;
        gsap.to(panel, {
          scale: 0.92,
          y: -28,
          filter: 'brightness(0.45)',
          ease: 'none',
          scrollTrigger: {
            trigger: panel,
            start: 'top top',
            end: 'bottom top',
            scrub: true,
            pin: true,
            pinSpacing: false,
          },
        });
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="stacked" id="journey" aria-label="Sanctuary residences">
      {PANELS.map((p) => (
        <article className="stacked__panel" key={p.num}>
          <img className="stacked__img" src={p.image} alt={p.alt} />
          <div className="stacked__panel-overlay" />
          <div className="stacked__content">
            <div className="stacked__num">{p.num} — Residence</div>
            <div>
              <h3 className="stacked__title">{p.title}</h3>
              <p className="stacked__sub">{p.sub}</p>
            </div>
            <div className="stacked__footer">
              <span>Puerto Rico · Northern Coast</span>
              <a href="#reserve" className="tlink" data-cursor="expand">
                View residence →
              </a>
            </div>
          </div>
        </article>
      ))}
    </section>
  );
}